'use strict';

import template from './review_form.html';

const RATES = [1, 2, 3, 4, 5];
const saReviewForm = [
  'reviews',

  function (reviews) {
    return {
      template: template,
      scope: {
        revieweeId: '@',
        onSave: '&'
      },
      link: function ($scope) {
        $scope.rates = RATES;
        $scope.review = {
          rate: RATES[RATES.length - 1]
        };

        $scope.leaveReview = function () {
          $scope.isSendButtonEnabled = false;

          reviews.create($scope.revieweeId, $scope.review )
            .then(function () {
              $scope.onSave();
            })
            .finally(function () {
              $scope.isSendButtonEnabled = true;
            });
        };
      }
    };
  }
];

export default saReviewForm;



// WEBPACK FOOTER //
// ./app/src/directives/review_form.js